import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { AboutSettings } from 'assets/js/pages/account-settings/account-about/AboutSettings';
import { BrandingSettings } from 'assets/js/pages/account-settings/account-about/BrandingSettings';
import { LandingPageSettings } from 'assets/js/pages/account-settings/account-about/LandingPageSettings';
import { SubscriptionSettings } from 'assets/js/pages/account-settings/account-about/SubscriptionSettings';
import { VerificationSettings } from 'assets/js/pages/account-settings/account-about/VerificationSettings';
import { AddressFormDrawer } from 'components/address-form/AddressFormDrawer';
import { SettingsAddressForm } from 'components/address-form/SettingsAddressForm';
import { DrawerRoute } from 'components/drawer-route';
import * as NavMenu from 'components/nav-menu';
import { Permission, Permissions } from 'components/permissions';
import { Route } from 'components/router/Route';
import { TestIds } from 'constants/tests';

const AboutRoutes = {
    Branding: 'branding',
    LandingPage: 'landing-page',
    Verify: 'verify',
    Addresses: 'addresses',
    Subscription: 'subscription',
};

const AccountAboutRouter = () => {
    const match = useRouteMatch();

    return (
        <div className={'grid grid-cols-12 gap-4'}>
            <NavMenu.Root
                orientation="vertical"
                aria-label="About"
                className="col-span-full lg:col-span-3"
            >
                <NavMenu.Item exact to={`${match.url}`}>
                    Organization Profile
                </NavMenu.Item>
                <NavMenu.Item
                    exact
                    to={`${match.url}/${AboutRoutes.Addresses}`}
                    data-testid={TestIds.AccountSettings.About.Addresses}
                >
                    Addresses
                </NavMenu.Item>
                <NavMenu.Item
                    to={`${match.url}/${AboutRoutes.Branding}`}
                    data-testid={TestIds.AccountSettings.About.Branding}
                >
                    Branding
                </NavMenu.Item>
                <NavMenu.Item
                    to={`${match.url}/${AboutRoutes.LandingPage}`}
                    data-testid={TestIds.AccountSettings.About.LandingPage}
                >
                    Landing Page
                </NavMenu.Item>
                <NavMenu.Item
                    to={`${match.url}/${AboutRoutes.Verify}`}
                    data-testid={TestIds.AccountSettings.About.Verification}
                >
                    Account Verification
                </NavMenu.Item>
                <Permissions allowed={[Permission.Admin]}>
                    <NavMenu.Item
                        to={`${match.url}/${AboutRoutes.Subscription}`}
                        data-testid={TestIds.AccountSettings.About.Billing}
                    >
                        Subscription & Billing
                    </NavMenu.Item>
                </Permissions>
            </NavMenu.Root>

            <div className={`col-span-full lg:col-span-9`}>
                <Switch>
                    <Route exact={true} path={match.path} component={AboutSettings} />

                    <Route path={`${match.path}/${AboutRoutes.Addresses}`}>
                        {({ match }) => (
                            <>
                                <DrawerRoute
                                    path={[`${match?.path}/new`, `${match?.path}/:addressId/edit`]}
                                    exact
                                >
                                    <AddressFormDrawer />
                                </DrawerRoute>
                                <DrawerRoute
                                    path={[
                                        `${match?.path}/new/mailing`,
                                        `${match?.path}/:addressId/edit/mailing`,
                                    ]}
                                    exact
                                >
                                    <AddressFormDrawer isMailingAddress={true} />
                                </DrawerRoute>
                                <Switch>
                                    <Route path={match?.path} component={SettingsAddressForm} />
                                </Switch>
                            </>
                        )}
                    </Route>

                    <Route
                        path={`${match.path}/${AboutRoutes.Branding}`}
                        component={BrandingSettings}
                    />
                    <Route
                        path={`${match.path}/${AboutRoutes.LandingPage}`}
                        component={LandingPageSettings}
                    />

                    <Route
                        path={`${match.path}/${AboutRoutes.Verify}`}
                        component={VerificationSettings}
                    />

                    <Permissions
                        allowed={[Permission.Admin]}
                        fallback={<Redirect to={`${match.url}/${AboutRoutes.Branding}`} />}
                    >
                        <Route
                            path={`${match.path}/${AboutRoutes.Subscription}`}
                            component={SubscriptionSettings}
                        />
                    </Permissions>
                    <Route>
                        <Redirect to={match.url} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
};

export { AccountAboutRouter };
